var exports = {
  "i": "x24da60e8--e07c19--wrapper",
  "V": "x24da60e8--e07c19--subtitle",
};

module.exports = exports;
